import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, TrendingDown } from 'lucide-react';

// Canon card wrappers mimicking ui-canon Card until a shared Card is formalized
const Card = ({ className = '', children }) => (
  <div className={`relative rounded-md border border-succession-border bg-succession-bg-primary ${className}`}>{children}</div>
);
const CardContent = ({ className = '', children }) => (
  <div className={`p-6 ${className}`}>{children}</div>
);

export default function ValuationMetricCard({ title, value, change, changeLabel, icon: Icon, iconColor = 'text-green-500', index = 0 }) {
  const isPositive = typeof change === 'number' ? change >= 0 : undefined;
  return (
    <motion.div initial={{ y: 20, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.4, delay: index * 0.1 }}>
      <Card className="hover:border-green-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-green-500/10">
        <div className="absolute inset-0 overflow-hidden rounded-md pointer-events-none">
          <div className="absolute -right-4 -top-4 opacity-5">
            {Icon ? <Icon className="w-24 h-24" /> : null}
          </div>
        </div>
        <CardContent>
          <div className="relative">
            <div className="flex items-start justify-between mb-4">
              <div className={`p-3 rounded-lg bg-green-500/10 ${iconColor}`}>{Icon ? <Icon className="w-5 h-5" /> : null}</div>
              {typeof change === 'number' && (
                <div className={`flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${isPositive ? 'bg-green-500/10 text-green-600' : 'bg-red-500/10 text-red-600'}`}>
                  {isPositive ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
                  <span>{Math.abs(change)}%</span>
                </div>
              )}
            </div>
            <div className="mb-2">
              <div className="text-3xl font-bold text-succession-text-primary mb-1">{value}</div>
              <div className="text-sm text-succession-text-secondary font-medium">{title}</div>
            </div>
            {changeLabel && <div className="text-xs text-succession-text-secondary">{changeLabel}</div>}
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
}


